var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9154_3270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 0H2.33325C1.04663 0 0 1.04663 0 2.33325V8.33325C0 9.62012 1.04663 10.6667 2.33325 10.6667H12.3333C13.6201 10.6667 14.6667 9.62012 14.6667 8.33325V2.33325C14.6667 1.04663 13.6201 0 12.3333 0ZM12.3333 13.3333H2.33325C1.04663 13.3333 0 14.3799 0 15.6667V29.6667C0 30.9534 1.04663 32 2.33325 32H12.3333C13.6201 32 14.6667 30.9534 14.6667 29.6667V15.6667C14.6667 14.3799 13.6201 13.3333 12.3333 13.3333ZM29.6667 21.3333H19.6667C18.3799 21.3333 17.3333 22.3799 17.3333 23.6667V29.6667C17.3333 30.9534 18.3799 32 19.6667 32H29.6667C30.9534 32 32 30.9534 32 29.6667V23.6667C32 22.3799 30.9534 21.3333 29.6667 21.3333ZM29.6667 0H19.6667C18.3799 0 17.3333 1.04663 17.3333 2.33325V16.3333C17.3333 17.6201 18.3799 18.6667 19.6667 18.6667H29.6667C30.9534 18.6667 32 17.6201 32 16.3333V2.33325C32 1.04663 30.9534 0 29.6667 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9154_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/Dashboard-Active.1632d391b4b80b4aa9f5d1aa145ee90f.svg";
export { ForwardRef as ReactComponent };